/**
 * キャラアセットの種別を URL の拡張子から決める。
 *
 * **AR 側 (services/event/ar の chest.ts tryLoadCharacter) と同じ順序**で判定する。
 * ここがずれると「3D と表示されたのに AR では画像」が起きる。
 *
 * 管理画面のプレビューと、客が集めたキャラの一覧で共有する — 二重定義にすると
 * 片方だけ直して食い違う。
 */
export type CharacterKind = 'model' | 'video' | 'image'

export function characterKind(url: string): CharacterKind {
  const lower = url.toLowerCase()
  if (lower.includes('.glb')) return 'model'
  if (/\.(mp4|webm)/.test(lower)) return 'video'
  return 'image'
}
